import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { PiSolarPanelDuotone } from "react-icons/pi";
import { withStyles } from '@material-ui/core/styles';

const styles = {
  countContainer: {
    height: 52,
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "space-around",
    textAlign: "center",
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  },
};

const StationStatisticsTotalize = ({ statisticsTotalize, currentYear, classes }) => {
  return (
    <Paper className='StationStatisticsBG'>
      <Grid container spacing={8}>
        <Grid item md sm={6} xs={6} >
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>              
            <PiSolarPanelDuotone className="panel-icon" />  System Capacity ({currentYear})</Typography>
            {(statisticsTotalize) ? parseFloat(statisticsTotalize.systemCapacity).toFixed(1) : 0} kWp
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6} >
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>⚡ Annual Energy Yields ({currentYear})</Typography>
            {(statisticsTotalize) ? (parseInt(statisticsTotalize.annualEnergyYields) / 1000).toFixed(1) : 0} MWh
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>📈 Annual Performance Ratio ({currentYear})</Typography>
            {(statisticsTotalize) ? Math.ceil(parseFloat(statisticsTotalize.annualPerformanceRatio)).toFixed(1) : 0}%
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>☀️ Annual Insolations ({currentYear})</Typography>
            {(statisticsTotalize) ? parseFloat(statisticsTotalize.annualInsolation).toFixed(0) : 0} kWh/m²/year
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6} >
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>📊 Average Annual Degradation ({currentYear})</Typography>
            {(statisticsTotalize) ? parseInt(statisticsTotalize.averageAnnualDegration).toFixed(1) : 0}%
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(StationStatisticsTotalize);
